import { bffApi } from "../../autogen/bff-api";

export const tagsInvalidatedByCreateBid = (_result: unknown, error: unknown) =>
  error ? (["BidV2", "SourcingEvent"] as const) : (["BidV2"] as const);

bffApi.enhanceEndpoints({
  endpoints: {
    createBid: {
      invalidatesTags: (result, error) => [...tagsInvalidatedByCreateBid(result, error)],
    },
  },
});
